import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=22f98713&scoped=true&"
import script from "./InputCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=22f98713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f98713",
  null
  
)

export default component.exports